export default {
  catSubjects: [],
  catDomains: [],
  activeAssignments: [],
  filterProficiencyHistory: {},
  filterProficiencyRank: {},
  classtingTotalScore: 1300,
  catDescription: {
    isNotAssignment: [
      'common.sam_comment_1',
      'common.sam_comment_2',
      'common.sam_comment_3',
      'common.sam_comment_4',
      'common.sam_comment_5',
    ],
    returnVisit: 'common.sam_return_visit_comment',
    isParent: 'common.sam_parent_comment',
  },
  childProficiencyHistory: {},
  childProficiencyRank: {},
  selectedLectureSubjectId: 0,
  filterVideoLectures: {},
  filterVideoLecturesPosition: {},
  filterCardLectures: {},
  filterCardLecturesPosition: {},
  lecturesType: [
    {
      id: 1,
      name: 'common.video_lecture',
    },
    {
      id: 2,
      name: 'common.card_lecture',
    },
  ],
  subjectMap: [],
  busy: false,
  countries: [],
  userCountry: {},
};



// WEBPACK FOOTER //
// ./src/app/cat-main/store/state.js